@if (tenant?.enabled_features?.new_onboarding) {
  <div class="u-width-100" fxLayout="column" fxLayoutAlign="center center">
    @for (connection of ssoConnections; track connection._id) {
      <button
        [attr.aria-labelledby]="'buttonLabel_' + connection._id"
        [ngStyle]="{ 'max-width': '500px', height: '64px' }"
        (click)="ssoSignIn(connection)"
        class="u-width-100 u-marginBottom-24"
        color="primary"
        mat-stroked-button
      >
        <p [ngStyle]="{ 'font-size': '18px' }" fxLayoutAlign="center">
          @if (connection.logoUrl; as logoUrl) {
            <img
              [ngSrc]="logoUrl"
              alt=""
              class="u-marginRight-8"
              height="18"
              width="18"
            />
          }
          <span
            id="buttonLabel_{{ connection._id }}"
            class="color-text-subdued"
          >
            @if (isSignupPage) {
              <ng-container i18n="@@ssoSigninView.signUpWith"
                >Sign up with</ng-container
              >
            } @else {
              <ng-container i18n="@@ssoSigninView.logInWith"
                >Log in with</ng-container
              >
            }
            {{ connection.display_name }}
          </span>
        </p>
      </button>
    }
    @if (tenant?.email_login_enabled) {
      <button
        [ngStyle]="{ 'max-width': '500px', height: '64px' }"
        (click)="authWithEmailHandler()"
        class="u-width-100 u-marginBottom-24"
        color="primary"
        mat-raised-button
      >
        <mat-icon class="material-icons-outlined md-18">mail</mat-icon>
        <p [ngStyle]="{ 'font-size': '18px' }">
          @if (isSignupPage) {
            <ng-container i18n="@@ssoSigninView.signUpWithEmail"
              >Sign up with email
            </ng-container>
          } @else {
            <ng-container i18n="@@ssoSigninView.logInWithEmail"
              >Log in with email
            </ng-container>
          }
        </p>
      </button>
    }
    @if (ssoError?.message) {
      <p class="u-padding-16 color-orange text-caption">
        <ng-container
          i18n="@@ssoSigninView.errorMessage"
          >{ssoError.message, select, other {{{ ssoError.message }}}
        }</ng-container>
      </p>
    }
  </div>
} @else {
  <p
    i18n="@@ssoSigninView.description"
    class="u-marginBottom-16 color-grey-300"
  >
    This community allows you to sign in with:
  </p>
  @for (connection of ssoConnections; track connection._id) {
    @if (
      1 === ssoConnections.length &&
      ('GoogleOAuth' === connection.connection_type ||
        'GoogleSAML' === connection.connection_type)
    ) {
      <button
        [ngStyle]="{
          height: '46px',
          width: '191px',
          'background-image':
            'url(https://storage.googleapis.com/ttc-static-images/button/btn_google_signin_dark_normal_web%402x.png)',
          'background-position': 'center',
          'background-repeat': 'no-repeat',
          'background-size': 'contain',
        }"
        (click)="ssoSignIn(connection)"
        aria-label="Sign in with Google"
        i18n-aria-label="@@ssoSigninView.googleCta"
        class="c-button u-marginBottom-8"
      ></button>
    } @else if (
      1 === ssoConnections.length && 'AzureSAML' === connection.connection_type
    ) {
      <button
        [ngStyle]="{
          height: '41px',
          width: '215px',
          'background-image':
            'url(https://storage.googleapis.com/ttc-static-images/button/microsoft_signin_dark.svg)',
          'background-position': 'center',
          'background-repeat': 'no-repeat',
          'background-size': 'contain',
        }"
        (click)="ssoSignIn(connection)"
        aria-label="Sign in with Microsoft"
        i18n-aria-label="@@ssoSigninView.microsoftCta"
        class="c-button u-marginBottom-8"
      ></button>
    } @else {
      <button
        [attr.aria-labelledby]="'buttonLabel_' + connection._id"
        (click)="ssoSignIn(connection)"
        class="u-width-100 u-marginBottom-8"
        color="primary"
        mat-stroked-button
      >
        <p fxLayoutAlign="center">
          @if (connection.logoUrl; as logoUrl) {
            <img
              [ngSrc]="logoUrl"
              alt=""
              class="u-marginRight-8"
              height="18"
              width="18"
            />
          }
          <span
            id="buttonLabel_{{ connection._id }}"
            i18n="@@ssoSigninView.defaultCta"
          >
            Sign in with
            {{ connection.display_name }}
          </span>
        </p>
      </button>
    }
  }
  @if (ssoError?.message) {
    <p class="u-padding-16 color-orange text-caption">
      <ng-container
        i18n="@@ssoSigninView.errorMessage"
        >{ssoError.message, select, other {{{ ssoError.message }}}
      }</ng-container>
    </p>
  }
  @if (showPrivacyDisclaimer) {
    <p class="text-caption color-grey-300 u-marginTop-8 u-marginBottom-8">
      @if (!tenant?.legal?.link) {
        <ng-container i18n="@@ssoSigninView.tosPrivacyDisclaimer">
          By clicking Sign in above, you are agreeing to our
          <a
            class="color-blue"
            href="https://www.tenthousandcoffees.com/terms-conditions"
            >Terms of Service</a
          >
          and
          <a
            class="color-blue"
            href="https://www.tenthousandcoffees.com/privacy-policy"
            >Privacy Policy</a
          >.
        </ng-container>
      } @else {
        <ng-container i18n="@@ssoSigninView.tosPrivacyLegalDisclaimer">
          By clicking Sign in above, you are agreeing to our
          <a
            class="color-blue"
            href="https://www.tenthousandcoffees.com/terms-conditions"
            >Terms of Service</a
          >,
          <a
            class="color-blue"
            href="https://www.tenthousandcoffees.com/privacy-policy"
            >Privacy Policy</a
          >
          and {{ tenant.friendly_name | textToPossessive }}
          <a [href]="tenant.legal.link" class="color-blue" target="_blank">{{
            tenant.legal.title
          }}</a
          >.
        </ng-container>
      }
    </p>
  }
}
